// اضافه کردن کتابخانه ها به صفحه
import * as React from "react";
import NavBar from "../../components/NavBar";
import {useTranslation} from "react-i18next";
import {Backdrop, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Pagination, PaginationItem} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {ReactComponent as Plus} from "../../assets/img/icons/plus.svg";
import CancelIcon from "@mui/icons-material/Cancel";
import {setLoading} from "../../redux/loading/actions";
import {ArrowBack, ArrowCircleDown, ArrowForward} from "@mui/icons-material";
import {useSnackbar} from "notistack";
import FileSaver from 'file-saver';
import {checkNonZeroPrefix, removeNonNumeric} from "../../assets/js/main";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import HandleFetchData from "../../plugin/HandleFetchData";
import {ThemeContext} from "../../App";


export default function RequestFactor() {
  // استفاده از متود های i18n برای چند زبان کردن پروژه و تغییر زبان پروژه
  const {t} = useTranslation()
  const {enqueueSnackbar} = useSnackbar();
  const {fetchData} = HandleFetchData()
  const location = useLocation();

  const navigate = useNavigate();
  const theme = React.useContext(ThemeContext)
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const [requestFactorDialog, setRequestFactorDialog] = React.useState(false);
  const [page, setPage] = React.useState(1);

  const [validations, setValidations] = React.useState(null);
  const [factorList, setFactorList] = React.useState(null);

  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [nationalCode, setNationalCode] = React.useState('');
  const [economicCode, setEconomicCode] = React.useState('');
  const [foriegnCode, setForiegnCode] = React.useState('');
  const [postalCode, setPostalCode] = React.useState('');
  const [address, setAddress] = React.useState('');

  React.useEffect(() => {
    handlerGetFactor(1)
  }, [])


  const handlerGetFactor = async (page) => {
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'GET', '/getFactorList', '',
       "application/json", {
         Page: page,
         PageSize: 10,
         datefrom: null,
         dateto: null
       }, '',''
    )
    setFactorList(fetch?.data)
    dispatch(setLoading(false))
  }

  const handlerDownload = async (id) => {
    dispatch(setLoading(true))
    var pdfUrl = `https://postex.ir/api/downloadFactor?requestFactorId=${id}`; // Replace with the actual PDF URL
    var myHeaders = new Headers();
    myHeaders.append("token", localStorage.getItem('token'));

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(pdfUrl, requestOptions)
       .then(response => response.blob())
       .then(blob => {
         var link = document.createElement('a');
         link.href = window.URL.createObjectURL(blob);
         link.download = `${+new Date()}.pdf`;
         link.click();
         dispatch(setLoading(false))
       })
       .catch(error => {
         console.log('error', error)
         dispatch(setLoading(false))
       });
  }

  const handlerValidations = () => {
    !firstName ? setValidations({
         firstName_validations: 'وارد کردن نام الزامی میباشد'
       }) :
       !lastName ? setValidations({
            lastName_validations: 'وارد کردن نام خانوادگی الزامی میباشد'
          }) :
          !nationalCode ? setValidations({
               nationalCode_validations: 'وارد کردن کد ملی الزامی میباشد'
             }) :
             !economicCode ? setValidations({
                  economicCode_validations: 'وارد کردن کد اقتصادی الزامی میباشد'
                }) :
                !postalCode ? setValidations({
                     postalCode_validations: 'وارد کردن کد پستی الزامی میباشد'
                   }) :
                   !checkNonZeroPrefix(postalCode) ? setValidations({
                     postalCode_validations: 'کدپستی وارد شده نامعتبر میباشد'
                   }) :
                   !postalCode ? setValidations({
                     postalCode_validations: 'وارد کردن آدرس الزامی میباشد'
                   }) : handlerRequestFactor()

  }

  const handlerRequestFactor = async () => {
    setRequestFactorDialog(false)

    dispatch(setLoading(true))
    let fetch = await fetchData('', 'POST', '/SaveFactorRequest', {
         "FirstName": firstName,
         "LastName": lastName,
         "NationalCode": nationalCode,
         "EconomicCode": economicCode,
         "ForiegnCode": foriegnCode,
         "Address": address,
         "Description": "",
         "ZipPostalCode": postalCode,
       },
       "application/json", '', '',''
    )

    if (fetch?.success) {
      enqueueSnackbar(fetch?.message, {
        variant: 'success',
        TransitionProps: {
          direction: 'down',
        },
        anchorOrigin: {
          horizontal: 'center',
          vertical: 'top'
        }
      })

    } else if (fetch && fetch?.status == 500) {
      navigate({
        pathname: "/pageInternalServer",
        search: location?.search
      });
    }else {
      enqueueSnackbar(fetch?.message, {
        variant: 'error',
        TransitionProps: {
          direction: 'down',
        },
        anchorOrigin: {
          horizontal: 'center',
          vertical: 'top'
        }
      })
    }
    setValidations(null)
    dispatch(setLoading(false))
  }


  const handleChangePagination = (event, value) => {
    handlerGetFactor(value)
    setPage(value);
  };

  return (
     <>
       {selector?.loading?.isLoading &&
       <div className="backdrop-loading">
         <div className="backdrop-bg">
           <div className="loader" style={theme.darkMode ? {backgroundImage: "url('/splash2.gif')"} : {backgroundImage: "url('/splash1.gif')"}}/>
         </div>
       </div>
       }

       {/*کامپوننت نوبار*/}
       <div className="d-block d-lg-none">
         <NavBar blue back/>
       </div>

       <div className="container">
         <div className="requestFactorPage desktopSection">
           <div className="requestFactorFilter">
             <h4 className="titleSection">{t("dashboard.requestFactor.t1")}</h4>

             <div className="btnGroup_yellow">
               <button onClick={() => setRequestFactorDialog(true)} className="btnFill" id="openRequestFactorDialog">
                 <span>{t("dashboard.requestFactor.t2")}</span>
               </button>
             </div>
           </div>


           <table>
             <thead>
             <tr>
               <th style={{width: '80%'}}>{t("singleOrder.invoice.t6")}</th>
               <th style={{width: '20%'}}>{t("singleOrder.invoice.t8")}</th>
             </tr>
             </thead>
             <tbody>

             {
               factorList?.items?.map(item => {
                 return <tr className="bodyTable" key={item?.Id}>
                   <td>{item?.Id + ' - ' + (item?.ConfirmState ? item?.ConfirmState : t("dashboard.requestFactor.t11"))}</td>
                   <td>
                     <div className="_btnGroup_yellow m-0">
                       <button onClick={() => handlerDownload(item?.Id)} className="btnFill" id="handlerDownload">
                         <ArrowCircleDown/>
                       </button>
                     </div>
                   </td>
                 </tr>
               })
             }

             </tbody>
           </table>

           {
             !factorList?.items?.length && <div className="notFindMessage">
               <img src={require('./../../assets/img/vector/1.png')} alt="vector" loading="lazy"/>
               <p>{t("error.t2")}</p>
             </div>
           }

           {
             factorList?.total > 0 &&
             <div className="paginate">
               <Pagination
                  count={factorList?.total} page={page} onChange={handleChangePagination}
                  renderItem={(item) => (
                     <PaginationItem
                        slots={{previous: ArrowBack, next: ArrowForward}}
                        {...item}
                     />
                  )}
               />
             </div>
           }


         </div>


         {/*ser coordinate dialog*/}
         <Dialog
            open={requestFactorDialog}
            onClose={() => setRequestFactorDialog(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="requestFactorDialog"
         >
           <DialogTitle id="alert-dialog-title">
             <div className="icon ">
               <Plus/>
             </div>
           </DialogTitle>
           <DialogContent>
             <div className="closed">
               <button type="button" onClick={() => setRequestFactorDialog(false)} id="closeRequestFactorDialog">
                 <CancelIcon/>
               </button>
             </div>
             <h5>{t("dashboard.requestFactor.t2")}</h5>

             <div className="row">
               <div className="col-12 col-md-6">
                 <label className="required">{t("dashboard.requestFactor.t3")}</label>
                 <input type="text" name="firstName" id="firstName"
                        value={firstName}
                        onChange={e => setFirstName(e.target.value)}/>

                 {
                   validations?.firstName_validations &&
                   <p className="error">{validations?.firstName_validations}</p>
                 }

               </div>
               <div className="col-12 col-md-6">
                 <label className="required">{t("dashboard.requestFactor.t4")}</label>
                 <input type="text" name="lastName" id="lastName"
                        value={lastName}
                        onChange={e => setLastName(e.target.value)}/>

                 {
                   validations?.lastName_validations &&
                   <p className="error">{validations?.lastName_validations}</p>
                 }

               </div>
               <div className="col-12 col-md-6">
                 <label className="required">{t("dashboard.requestFactor.t5")}</label>
                 <input type="text" name="nationalCode" id="nationalCode"
                        value={nationalCode} className="numeric"
                        onChange={e => setNationalCode(removeNonNumeric(e.target.value))}/>

                 {
                   validations?.nationalCode_validations &&
                   <p className="error">{validations?.nationalCode_validations}</p>
                 }

               </div>
               <div className="col-12 col-md-6">
                 <label className="required">{t("dashboard.requestFactor.t6")}</label>
                 <input type="text" name="economicCode" id="economicCode"
                        value={economicCode} className="numeric"
                        onChange={e => setEconomicCode(removeNonNumeric(e.target.value))}/>

                 {
                   validations?.economicCode_validations &&
                   <p className="error">{validations?.economicCode_validations}</p>
                 }

               </div>
               <div className="col-12 col-md-6">
                 <label className="">{t("dashboard.requestFactor.t7")}</label>
                 <input type="text" name="foriegnCode" id="foriegnCode"
                        value={foriegnCode} className="numeric"
                        onChange={e => setForiegnCode(removeNonNumeric(e.target.value))}/>

                 {
                   validations?.foriegnCode_validations &&
                   <p className="error">{validations?.foriegnCode_validations}</p>
                 }

               </div>
               <div className="col-12 col-md-6">
                 <label className="required">{t("dashboard.requestFactor.t8")}</label>
                 <input type="text" name="postalCode" id="postalCode"
                        value={postalCode} className="numeric"
                        onChange={e => setPostalCode(removeNonNumeric(e.target.value))}/>

                 {
                   validations?.postalCode_validations &&
                   <p className="error">{validations?.postalCode_validations}</p>
                 }

               </div>
               <div className="col-12">
                 <label className="required">{t("dashboard.requestFactor.t9")}</label>
                 <textarea rows="2" value={address} id="address"
                           onChange={e => setAddress(e.target.value)}/>

                 {
                   validations?.address_validations &&
                   <p className="error">{validations?.address_validations}</p>
                 }

               </div>


             </div>

           </DialogContent>
           <DialogActions>
             <Button className="yellow" onClick={handlerValidations} id="handlerValidations">
               {t("dashboard.requestFactor.t10")}
             </Button>
           </DialogActions>
         </Dialog>
       </div>
     </>
  )

}
